import React from 'react';
import styled from 'styled-components';
import ImageWrapper from '../global/imageWrapper/imageWrapper';
import CtaBreakerModel from '../../models/cta-breaker';
import LinkButton from '../global/linkButton/linkButton';
import Richtext from '../global/richtext/Richtext';
import styles from './cta-breaker.module.scss';

type Props = {
  data: CtaBreakerModel;
};

interface CProps {
  backgroundColor?: string;
  backgroundImage?: string;
  fontColor?: string;
}

const CustomStyles = styled.div`
  ${(p: CProps) =>
    p.backgroundColor && `background-color: ${p.backgroundColor};`}
  ${(p: CProps) => p.fontColor && `color: ${p.fontColor};`}
  ${(p: CProps) =>
    p.backgroundImage &&
    `
    background-image: url('${p.backgroundImage}');
    background-size: cover;
    background-position: center center;
    background-repeat: no-repeat;
  `}
`;

const CtaBreaker = ({ data }: Props) => {
  if (!data) return <></>;

  const {
    backgroundColor,
    backgroundImage,
    foregroundImage,
    description,
    eyebrow,
    eyebrowColor,
    links
  } = data;

  return (
    <CustomStyles
      backgroundColor={backgroundColor}
      className={styles['cta-breaker']}
      backgroundImage={(backgroundImage && backgroundImage.src) || ''}
    >
      <div className={styles['cta-breaker__description']}>
        {(description || eyebrow || links) && (
          <div>
            {eyebrow && (
              <CustomStyles
                className={styles['cta-breaker__description-eyebrow']}
                fontColor={eyebrowColor}
              >
                {eyebrow}
              </CustomStyles>
            )}
            {description && (
              <Richtext
                customClasses={{
                  header: styles['cta-breaker__description-title'],
                  paragraph: styles['cta-breaker__description-paragraph']
                }}
                data={description}
              />
            )}
            {links && (
              <div className={styles['cta-breaker__links-container']}>
                {links.map((link) => (
                  <div key={link.label}>
                    {link.tags && link.tags.includes('line-break') && (
                      <div className={styles['cta-breaker__line-break']} />
                    )}
                    <LinkButton
                      linkClass={styles['cta-breaker__link']}
                      iconClass={styles['cta-breaker__link-icon']}
                      data={link}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles['cta-breaker__image-container']}>
        {foregroundImage && (
          <ImageWrapper
            {...foregroundImage}
            layout="intrinsic"
            parallax={false}
          />
        )}
      </div>
    </CustomStyles>
  );
};

export default CtaBreaker;
